<section class="grid gap-4">
  <div class="flex items-center justify-between gap-3">
    <div>
      <page-title [title]="'Profile'"></page-title>
    </div>
    <!-- <button mat-stroked-button type="button" (click)="loadProfile()" [disabled]="loading() || saving()">Refresh</button> -->
    <button matButton="filled" type="button" (click)="loadProfile()">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </div>

  @if (loading() && !user()) {
    <mat-card class="p-6">
      <div class="flex items-center gap-3">
        <mat-spinner diameter="24" />
        Loading profile...
      </div>
    </mat-card>
  } @else {
    <div class="grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
      <app-user-info
        [title]="'Your details'"
        [user]="user()"
      />

      <update-user
        [title]="'Edit profile'"
        [submitLabel]="'Save profile'"
        [busy]="saving()"
        [initialValue]="user()"
        (submitted)="saveProfile($event)"
      />
    </div>
  }
</section>